import { supabase } from '@/lib/supabase';

export type SubjectListItem = {
  code: string | null;
  created_at: string;
  id: string;
  name: string;
};

export async function fetchSubjectsForSchool(schoolId: string) {
  const { data, error } = await supabase
    .from('subjects')
    .select('id, name, code, created_at')
    .eq('school_id', schoolId)
    .order('name', { ascending: true });

  if (error) {
    throw error;
  }

  return (data ?? []) as SubjectListItem[];
}

export async function createSubject(input: {
  code?: string;
  name: string;
  schoolId: string;
}) {
  const payload = {
    code: input.code?.trim() || null,
    name: input.name.trim(),
    school_id: input.schoolId,
  };

  const { error } = await supabase.from('subjects').insert(payload);

  if (error) {
    throw error;
  }
}

export async function updateSubject(input: {
  code?: string;
  name: string;
  schoolId: string;
  subjectId: string;
}) {
  const payload = {
    code: input.code?.trim() || null,
    name: input.name.trim(),
  };

  const { error } = await supabase
    .from('subjects')
    .update(payload)
    .eq('id', input.subjectId)
    .eq('school_id', input.schoolId);

  if (error) {
    throw error;
  }
}
